import type { CompanyTableViewRow } from '../types/company-table-column.types';

export function buildTableViewRows(rows: readonly Record<string, unknown>[]): CompanyTableViewRow[] {
  return rows.map((record, index) => ({
    id: String(record['id'] ?? `company-table-row-${index}`),
    record,
    checked: false,
    disabled: false,
  }));
}
